import {
  authHeader,
  config,
  handleError,
  handleResponse,
} from "../common/helpers";

const getBuildVersion = () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  return fetch("/build_version.json", requestOptions).then(
    handleResponse,
    handleError
  );
};

const virtualDemoSubmitQuestions = (data = {}) => {
  const requestOptions = {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };
  return fetch(config.apiUrl + "/submitquestions", requestOptions).then(
    handleResponse,
    handleError
  );
};

const eloquaFormSubmition = (data) => {
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };
  return fetch(config.eloquaUrl + "/", requestOptions).then(
    handleResponse,
    handleError
  );
};
const eloquaInit = () => {
  return fetch(config.eloquaUrl + "/", {
    method: "GET",
  }).then(handleResponse, handleError);
};
const forgotPasswordRequest = (data = {}) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(config.apiUrl + "/user/resetpassword", requestOptions).then(
    handleResponse,
    handleError
  );
};

const getUserInfoByEmail = (email) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      serviceType: true,
    },
  };
  return fetch(config.apiUrl + "/user/email/" + email, requestOptions).then(
    handleResponse,
    handleError
  );
};

const changePassword = (data) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      passwordResetId: data.passwordResetId,
      newPword: data.password,
    }),
  };
  return fetch(
    config.apiUrl + "/user/" + data.userId + "/setpassword",
    requestOptions
  ).then(handleResponse, handleError);
};

export const homeServices = {
  getBuildVersion,
  virtualDemoSubmitQuestions,
  eloquaFormSubmition,
  forgotPasswordRequest,
  eloquaInit,
  getUserInfoByEmail,
  changePassword,
};
